module.exports = __webpack_public_path__ + "img/code.fb2400af.png";